// extracted by mini-css-extract-plugin
module.exports = {"table":"DataTable_table__k8zTw","th":"DataTable_th__2TcQR","row":"DataTable_row__2Kwny","isSorted":"DataTable_isSorted__3tfEL"};